import { Button, ButtonVariant } from '@rhinofi/dvf-shared-ui'
import { Link } from 'react-router-dom'
import { modalKeys } from '../../../constants/modalKeys'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { translate } from '../../../intl/i18n'
import { publicRoutes } from '../../../router'
import { showModal } from '../../../store/actions/modalActions/showModal'
import { selectAddress } from '../../../store/selectors/user.selectors'
import { MobileHeaderContainer } from '../MobileNavigation.styled'
import { MenuConnectedWalletsButtonContent } from '../../Menu/MenuConnectedWalletsButtonContent'
import styled, { useTheme } from 'styled-components'
import { RhinoLogo } from '../../ui/RhinoLogo'

export const MobileHeader = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const walletAddress = useAppSelector(selectAddress)

  return (
    <MobileHeaderContainer>
      <Link to={publicRoutes.legacyRhinoClaim} className="logo-link">
        <RhinoLogo src={theme.assets.logo} alt="rhino logo" />
      </Link>
      {!walletAddress ? (
        <Button id="mobile-connect" onClick={() => showModal(dispatch)(modalKeys.connectWallet)}>
          {translate('global.connect')}
        </Button>
      ) : (
        <ConnectedWalletsButton
          id="mobile-connected-wallets"
          variant={ButtonVariant.ghost}
          onClick={() => {
            showModal(dispatch)(modalKeys.connectedWalletsMobile)
          }}
        >
          <MenuConnectedWalletsButtonContent />
        </ConnectedWalletsButton>
      )}
    </MobileHeaderContainer>
  )
}

const ConnectedWalletsButton = styled(Button)`
  padding: 0;
  margin: 0;
  border: none;
`
